import styled from "styled-components";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { colors } from "@sonder/ui/source/styled/theme";

export const SearchDropdownTrigger = styled(Button)`
  color: ${colors.gray1};
  height: 3rem;
  justify-content: space-between;
  padding: 0 0.857rem;
  width: 100%;

  & svg {
    font-size: ${props => props.iconSize};
    padding: 0;
  }
`;
